import React from "react";

// Decorative paint-splatter SVG, used as accent throughout the page.
export const Splat = ({ className = "", color = "#E91E63", style }) => (
  <svg
    aria-hidden="true"
    className={className}
    viewBox="0 0 200 200"
    fill="none"
    style={style}
  >
    <path
      fill={color}
      d="M100 8c10 18 30 14 44 30 13 14 6 36 22 46 17 11 30-2 32 18 2 18-20 22-22 38-2 17 16 26 0 40-16 14-32-6-50-2-16 4-22 26-40 22-19-3-14-26-30-34-15-7-34 2-38-14-4-15 16-22 18-38 1-13-16-22-10-36 6-13 26-6 36-20 8-12 22-30 38-50z"
    />
    <circle cx="40" cy="50" r="6" fill={color} />
    <circle cx="160" cy="40" r="9" fill={color} />
    <circle cx="170" cy="160" r="5" fill={color} />
    <circle cx="30" cy="160" r="7" fill={color} />
  </svg>
);

export const PaintDripDivider = ({ color = "#E91E63" }) => (
  <svg
    viewBox="0 0 1440 60"
    preserveAspectRatio="none"
    aria-hidden="true"
    className="w-full h-8 block"
  >
    <path
      fill={color}
      d="M0 0h1440v18c-40 0-40 22-80 22s-40-14-80-14-40 18-80 18-40-20-80-20-40 16-80 16-40-18-80-18-40 22-80 22-40-12-80-12-40 18-80 18-40-20-80-20-40 16-80 16-40-18-80-18-40 14-80 14-40-22-80-22-40 18-80 18-40-14-80-14V0z"
    />
  </svg>
);
